import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Panel } from 'react-bootstrap';
import LogMessageComponent from './../Components/LogMessageComponent';
import ImageComponent from './../Components/ImageComponent';
import ConditionalComponent from './../Components/ConditionalComponent';

const FailedTestArtifactsComponent = ({
  test,
  detailsVisible,
  fullPath,
  consoleLog,
  crashLog,
  imageB64,
  videoLink,
  axiomLog,
  eventLog,
  htmlLog,
  onExpandClick,
}) => {
  const expanded = detailsVisible[test] ? true : false;

  return (
    <Row>
      <Col md={12}>
        <Panel bsStyle="primary" collapsible="true" expanded={expanded}
          onToggle={() => {
            onExpandClick(detailsVisible, test, fullPath);
          }}
        >
          <Panel.Heading>
            <Panel.Title toggle>
              <div>
                {test}
              </div>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <ConditionalComponent
                condition={!htmlLog}
                children={
                  <ConditionalComponent
                    condition={!eventLog}
                    children={
                      <div>
                        <LogMessageComponent log={consoleLog} logType={'Console Log'} />
                        <LogMessageComponent log={crashLog} logType={'Crash Log'} />
                        {
                          axiomLog ?
                            <LogMessageComponent log={axiomLog} logType={'Axiom Log'} /> :
                            null
                        }
                        <ImageComponent
                          imageB64={imageB64}
                          videoLink={videoLink}
                        />
                      </div>
                    }
                    elseChildren={
                      <pre>
                        {eventLog}
                      </pre>
                    }
                  />
                }
                elseChildren={
                  <iframe srcDoc={htmlLog} width="100%" height="750" />
                }
              />
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </Col>
    </Row>
  );
};

FailedTestArtifactsComponent.propTypes = {
  test: PropTypes.string,
  detailsVisible: PropTypes.object,
  fullPath: PropTypes.string.isRequired,
  consoleLog: PropTypes.string,
  crashLog: PropTypes.string,
  imageB64: PropTypes.string,
  videoLink: PropTypes.string,
  axiomLog: PropTypes.string,
  eventLog: PropTypes.string,
  htmlLog: PropTypes.string,
  onExpandClick: PropTypes.func.isRequired,
};

export default FailedTestArtifactsComponent;


// WEBPACK FOOTER //
// src/Components/FailedTestArtifactsComponent.jsx